function getSessionId() {
  const savedSessionId = window.sessionStorage.getItem("vr-sid");
  return savedSessionId;
}

function isSignedIn() {
  const wmsSignedIn = window.sessionStorage.getItem("vr-loggedin");
  return wmsSignedIn && (wmsSignedIn.toLowerCase() === "true" || false);
}

function getClientCode() {
  return window.localStorage.getItem("vr-client-code");
}

function setClientCode(clientCode) {
  window.localStorage.setItem("vr-client-code", clientCode);
}

function signOut() {
  window.sessionStorage.setItem("vr-loggedin", false);
}

function setUserInfo(data) {
  const { result, sid, user_name, client_name } = data;
  const { sessionStorage } = window;
  if (result) {
    sessionStorage.setItem("vr-loggedin", true);
    sessionStorage.setItem("vr-sid", sid);
    sessionStorage.setItem("vr-user-name", user_name);
    sessionStorage.setItem("vr-client-name", client_name);
  }
}

function getUserInfo() {
  const { sessionStorage } = window;
  const userName = sessionStorage.getItem("vr-user-name");
  const clientName = sessionStorage.getItem("vr-client-name");

  return {
    userName,
    clientName,
  };
}

function resetUserInfo() {
  const { sessionStorage } = window;
  sessionStorage.removeItem("vr-loggedin");
  sessionStorage.removeItem("vr-sid");
  sessionStorage.removeItem("vr-user-name");
  sessionStorage.removeItem("vr-client-name");
}

export const SessionStorage = {
  getSessionId,
  getClientCode,
  setUserInfo,
  resetUserInfo,
  setClientCode,
  getUserInfo,
  isSignedIn,
  signOut,
};
